import { render, staticRenderFns } from "./SpinnerLoading.vue?vue&type=template&id=c538126c&scoped=true&"
var script = {}
import style0 from "./SpinnerLoading.vue?vue&type=style&index=0&id=c538126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c538126c",
  null
  
)

export default component.exports